import React from 'react'
import axios from "axios";
//import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import AdminNavFormProfile from './AdminNavFormProfile';
import Path from "./config";
class BasicRegi extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sbg_eng_first_name: '',
            sbg_eng_middle_name: '',
            sbg_eng_sirname: '',
            sbg_mobile_no: "",
            sbg_email_id: "",

            sbg_password: '',
            isValid: true,
            adminId: ''
        }

    }

    componentDidMount() {

        this.setState({
            userId: localStorage.getItem("userId"),
            admin: localStorage.getItem("admin"),
            adminid: localStorage.getItem("adminid")

        })
        //console.log("admin",localStorage.getItem("adminid"))
        axios.get(Path + 'Show_bride_groom_basicregi.php?sbg_id=' + localStorage.getItem("userId"))
            .then(function (response) {
                response = response.data;

                this.setState({

                    sbg_mobile_no: response.sbg_mobile_no,
                    sbg_email_id: response.sbg_email_id,
                    sbg_eng_first_name: response.sbg_eng_first_name,
                    sbg_eng_middle_name: response.sbg_eng_middle_name,
                    sbg_eng_sirname: response.sbg_eng_sirname,
                    sbg_password: response.sbg_password,

                })
            }.bind(this))


    }


    mobileHandler = (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            this.setState({ sbg_mobile_no: e.target.value })

            //console.log(this.state.sbg_mobile_no)
        }
    }
    emailHandler = (e) => {
        this.setState
            ({ sbg_email_id: e.target.value })
        // console.log(this.state.sbg_email_id)
    }


    engnameHandler = (e) => {
        document.getElementById("sbg_eng_first_name").style.borderColor = "";
        this.setState
            ({ sbg_eng_first_name: e.target.value })
        //console.log(this.state.sbg_eng_first_name)
    }

    engmiddlenameHandler = (e) => {
        document.getElementById("sbg_eng_middle_name").style.borderColor = "";
        this.setState
            ({ sbg_eng_middle_name: e.target.value })
        // console.log(this.state.sbg_eng_middle_name)
    }
    englastnameHandler = (e) => {
        document.getElementById("sbg_eng_sirname").style.borderColor = "";
        this.setState
            ({ sbg_eng_sirname: e.target.value })
        // console.log(this.state.sbg_eng_sirname)
    }



    passwordHandler = (e) => {
        document.getElementById("password").innerHTML = "";
        this.setState
            ({ sbg_password: e.target.value })
        //console.log(this.state.sbg_password)
    }


    submitClick = (e) => {
        // console.log("mob", this.state.sbg_mobile_no)

        e.preventDefault();

        if (this.state.sbg_mobile_no === "") {
            document.getElementById("mobileno").innerHTML = "Please Enter Mobile Number";
            this.setState({ isValid: false })
        }
        if (this.state.sbg_password === "") {
            document.getElementById("password").innerHTML = "Please Enter Password";
            this.setState({ isValid: false })
        }

        if (this.state.sbg_eng_first_name === "") {
            document.getElementById("sbg_eng_first_name").style.borderColor = "red";
            this.setState({ isValid: false })
        }

        if (this.state.sbg_eng_middle_name === "") {
            document.getElementById("sbg_eng_middle_name").style.borderColor = "red";
            this.setState({ isValid: false })
        }

        if (this.state.sbg_eng_sirname === "") {
            document.getElementById("sbg_eng_sirname").style.borderColor = "red";
            this.setState({ isValid: false })
        }


        e.preventDefault();
        let tempStr = "sbg_mobile_no=" + this.state.sbg_mobile_no +
            "&sbg_email_id=" + this.state.sbg_email_id +
            "&sbg_eng_first_name=" + this.state.sbg_eng_first_name +
            "&sbg_eng_middle_name=" + this.state.sbg_eng_middle_name +
            "&sbg_eng_sirname=" + this.state.sbg_eng_sirname +
            "&sbg_password=" + this.state.sbg_password +
            "&sbg_admin_login_id=" + this.state.adminId +
            "&userId=" + this.state.userId


        if (this.state.isValid === true) {

            //console.log("tempStr",tempStr)
            axios.post(Path + `Suchi_bride_groom_admin_register.php?` + tempStr)
                .then(function (response) {
                    console.log("response", response.data)
                    if (response.data) {
                        // localStorage.setItem("userId", response.data.sbg_id);
                        //localStorage.setItem("phoneId",this.state.sbg_mobile_no);
                        this.props.history.push(`/AdminProfile/PersonalInfo`);
                    }
                    // else if(response.data.Sucess ==='Present')
                    // {
                    //     alert("मोबाइल नंबर आधीपासून अस्तित्वात आहे.");
                    //     //this.props.history.push(`/AdminProfile`);
                    // }

                }.bind(this))

        }
    }


    render() {
        return (
            <>
                <AdminNavFormProfile />
                <div className="m-5 pt-3" >
                    <form className="row g-3">
                        <div className="col-md-4">
                            <label htmlFor="inputEmail4" className="form-label">*  वधू/वराचे नाव (फक्त इंग्रजीत )</label>
                            <input type="text" maxLength="20" className="form-control" id="sbg_eng_first_name" value={this.state.sbg_eng_first_name} onChange={this.engnameHandler} placeholder="First Name" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putPassword4" className="form-label">*  वडिलांचे नाव (फक्त इंग्रजीत )</label>
                            <input type="text" maxLength="20" value={this.state.sbg_eng_middle_name} id="sbg_eng_middle_name" onChange={this.engmiddlenameHandler} className="form-control" required placeholder="Middle Name" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="putPassword4" className="form-label">* आडनाव (फक्त इंग्रजीत ) </label>
                            <input type="text" maxLength="20" id="sbg_eng_sirname" value={this.state.sbg_eng_sirname} onChange={this.englastnameHandler} className="form-control" required placeholder="Surname" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="formGroupExampleInput" className="form-label">मोबईल नंबर <span id="mobileno" className="text-danger p-2"></span></label>
                            <input type="text" maxLength="13" className="form-control" value={this.state.sbg_mobile_no} onChange={this.mobileHandler} placeholder="Mobile Number" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="formGroupExampleInput2" className="form-label">ई मेल आय डी </label><span id="email" className="text-danger p-2"></span>
                            <input type="email" className="form-control" value={this.state.sbg_email_id} onChange={this.emailHandler} placeholder="Email Address" />
                        </div>
                        <div className="col-md-4">
                            <label htmlFor="formGroupExampleInput" className="form-label">पासवर्ड <span id="password" className="text-danger p-2"></span></label>
                            <input type="text" autoComplete="on" maxLength="6" className="form-control" onBlur={this.checkLength} value={this.state.sbg_password} onChange={this.passwordHandler} placeholder="Password" />
                        </div>

                        <div className="col-12">
                            <button type="submit" className="btn btn-primary" onClick={(e) => (this.submitClick) ? this.submitClick(e) : null}>Save & Next ▶️</button>
                        </div>
                    </form>
                </div>
            </>
        )
    }
}

export default BasicRegi
